import axios from 'axios';
import router from '../router';

const setup = () => {
  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      if (error.response && error.response.status === 401) {
        // Clear user data from local storage
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        // Redirect to login page
        router.push('/');
      }
      return Promise.reject(error);
    }
  );
};

export default setup;
